import { Table as MaintenanceTaskTable } from '@/components/maintenance_type_task/table'
import { Form as NewForm } from '@/components/maintenance_type_task/new_form'

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  return (
    <div>
      <NewForm id={id} />
      <MaintenanceTaskTable filters={{ maintenanceTypeIdEq: id }} />
    </div>
  )
}
